import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=70ad4e1c&scoped=true"
import script from "./SidebarItem.vue?vue&type=script&lang=js"
export * from "./SidebarItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&id=70ad4e1c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ad4e1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ad4e1c')) {
      api.createRecord('70ad4e1c', component.options)
    } else {
      api.reload('70ad4e1c', component.options)
    }
    module.hot.accept("./SidebarItem.vue?vue&type=template&id=70ad4e1c&scoped=true", function () {
      api.rerender('70ad4e1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layout/components/SidebarA/SidebarItem.vue"
export default component.exports